"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lottieReact = _interopRequireDefault(require("lottie-react"));
var _moment = _interopRequireDefault(require("moment"));
var _ = require("..");
var _pricing = require("../../helpers/pricing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PaymentSuccess = function PaymentSuccess(_ref) {
  var payment = _ref.payment;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement(_lottieReact["default"], {
    className: "icon icon--xl",
    animationData: _.lottieSuccess,
    loop: false
  }), /*#__PURE__*/_react["default"].createElement("h3", null, "Payment successful!")), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "full-width margin-y-lg border d8-u-radius-md"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, !!payment && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, payment.method && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-medium"
  }, "Type"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold"
  }, payment.method)), payment.datePaid && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-medium"
  }, "Date"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold"
  }, (0, _moment["default"])(payment.datePaid).format('MMMM Do YYYY, h:mm:ss A'))), payment.status && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-medium"
  }, "Status"), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_.Pill, {
    title: payment.status,
    type: _.PILL_TYPES.SUCCESS_INVERT
  }))), payment.amountPaid && payment.currencyPaid && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-contrast-medium"
  }, "Amount paid"), /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-text-bold"
  }, (0, _pricing.formatCurrency)(payment.amountPaid / 100, payment.currencyPaid))))));
};
PaymentSuccess.propTypes = {
  payment: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = PaymentSuccess;